import './TechToolCard.scss';
import { TechTool } from 'types/TechTool';
import React, { MouseEventHandler } from 'react';

interface TechToolCardProps {
  techtool: TechTool,
  onClick?: MouseEventHandler | undefined
}

const TechToolCard: React.FC<TechToolCardProps> = ({ techtool, onClick }) => {
  return (
    <div className="techtool-card">
      <div className="techtool-card__header" onClick={onClick}>
        <div className="techtool-card__header-title">
          <div className="techtool-card__header-serial">
            {techtool.title} 
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechToolCard;